import React, { useEffect } from 'react';

function AgenciaModal({ show, onClose, onSubmit, form, handleChange, bancos = [], ufs = [], cidades = [], title = 'CADASTRO DE AGÊNCIA' }) {
  useEffect(() => {
    if (!show) return;
    if (bancos.length === 1 && !form.idBanco) {
      handleChange({ target: { name: 'idBanco', value: bancos[0].id } });
    }
  }, [show, bancos.length]);

  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-buildings me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form id="agencia-form" onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Banco *</label>
                <select className="form-select form-select-sm" name="idBanco" value={form.idBanco} onChange={handleChange} required>
                  <option value="">Selecione...</option>
                  {bancos.map(b => <option key={b.id} value={b.id}>{b.id} - {b.nome}</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Agência *</label>
                <input type="text" className="form-control form-control-sm" name="idAgencia" value={form.idAgencia} onChange={handleChange} required />
              </div>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="form-label">UF</label>
                  <select className="form-select form-select-sm" name="uf" value={form.uf} onChange={handleChange}>
                    <option value="">--</option>
                    {ufs.map((u, i) => <option key={i} value={u.sigla}>{u.sigla}</option>)}
                  </select>
                </div>
                <div className="col-md-9 mb-3">
                  <label className="form-label">Cidade</label>
                  <select className="form-select form-select-sm" name="cidade" value={form.cidade} onChange={handleChange} disabled={!form.uf}>
                    <option value="">{form.uf ? 'Selecione...' : 'Selecione uma UF'}</option>
                    {cidades.map((c, i) => <option key={i} value={c.nome}>{c.nome}</option>)}
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer" style={{ padding: '0.35rem 1rem' }}>
            <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
            <button type="submit" form="agencia-form" className="btn btn-success btn-sm">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgenciaModal;
